// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");

function makeParserInput(tokens) {
  return {
          tokens: tokens,
          begin: 0
        };
}

function parseL(tokens, parser) {
  return Core__Option.map(parser()({
                  tokens: tokens,
                  begin: 0
                }), (function (param) {
                return param.data;
              }));
}

function parse(tokens, parser) {
  return parseL(tokens, (function () {
                return parser;
              }));
}

function toInput(parsed) {
  return {
          tokens: parsed.tokens,
          begin: parsed.end + 1 | 0
        };
}

function isEmpty(inp) {
  return inp.tokens.length <= inp.begin;
}

function mapParsed(parser, func) {
  return function (inp) {
    return Core__Option.map(parser(inp), (function (parsed) {
                  return {
                          tokens: parsed.tokens,
                          begin: parsed.begin,
                          end: parsed.end,
                          data: func(parsed)
                        };
                }));
  };
}

function map(parser, func) {
  return function (inp) {
    return Core__Option.map(parser(inp), (function (parsed) {
                  return {
                          tokens: parsed.tokens,
                          begin: parsed.begin,
                          end: parsed.end,
                          data: func(parsed.data)
                        };
                }));
  };
}

function mapOpt(parser, func) {
  return function (inp) {
    var parsed = parser(inp);
    if (parsed !== undefined) {
      return Core__Option.map(func(parsed.data), (function (b) {
                    return {
                            tokens: parsed.tokens,
                            begin: parsed.begin,
                            end: parsed.end,
                            data: b
                          };
                  }));
    }
    
  };
}

function flatMap(parser, mapper) {
  return mapOpt(parser, (function (parsed) {
                var parser = mapper(parsed);
                return parseL(parsed, (function () {
                              return parser;
                            }));
              }));
}

function match(matcher) {
  return function (inp) {
    if (isEmpty(inp)) {
      return ;
    }
    var token = inp.tokens[inp.begin];
    return Core__Option.map(matcher(token), (function (data) {
                  return {
                          tokens: inp.tokens,
                          begin: inp.begin,
                          end: inp.begin,
                          data: data
                        };
                }));
  };
}

function repL(parser, minCntOpt, maxCnt) {
  var minCnt = minCntOpt !== undefined ? minCntOpt : 0;
  return function (inp) {
    var parser$1 = parser();
    var tokens = inp.tokens;
    var begin = inp.begin;
    var inp$1 = inp;
    var res = [];
    var end = -1;
    var mismatchFound = false;
    while(!mismatchFound && Core__Option.mapOr(maxCnt, true, (function (maxCnt) {
              return res.length < maxCnt;
            }))) {
      var parsed = parser$1(inp$1);
      if (parsed !== undefined) {
        res.push(parsed.data);
        end = parsed.end;
        inp$1 = toInput(parsed);
      } else {
        mismatchFound = true;
      }
    };
    if (res.length < minCnt) {
      return ;
    }
    var end$1 = res.length === 0 ? begin - 1 | 0 : end;
    return {
            tokens: tokens,
            begin: begin,
            end: end$1,
            data: res
          };
  };
}

function rep(parser, minCntOpt, maxCnt) {
  var minCnt = minCntOpt !== undefined ? minCntOpt : 0;
  return repL((function () {
                return parser;
              }), minCnt, maxCnt);
}

function optL(parser) {
  return map(repL(parser, undefined, 1), (function (found) {
                if (found.length === 1) {
                  return Caml_option.some(found[0]);
                }
                
              }));
}

function opt(parser) {
  return optL(function () {
              return parser;
            });
}

function seqL(parsers) {
  return function (inp) {
    return Core__Option.map(Core__Array.reduce(parsers, [
                    [],
                    -1,
                    -1,
                    inp
                  ], (function (ctx, parser) {
                      if (ctx === undefined) {
                        return ctx;
                      }
                      var datas = ctx[0];
                      var parsed = parser()(ctx[3]);
                      if (parsed !== undefined) {
                        datas.push(parsed.data);
                        return [
                                datas,
                                datas.length === 1 ? parsed.begin : ctx[1],
                                parsed.end,
                                toInput(parsed)
                              ];
                      }
                      
                    })), (function (param) {
                  return {
                          tokens: param[3].tokens,
                          begin: param[1],
                          end: param[2],
                          data: param[0]
                        };
                }));
  };
}

function seq(parsers) {
  return seqL(parsers.map(function (p) {
                  return function () {
                    return p;
                  };
                }));
}

function seq2L(parser1, parser2) {
  return function (inp) {
    return Core__Option.flatMap(parser1()(inp), (function (parsed1) {
                  return Core__Option.map(parser2()(toInput(parsed1)), (function (parsed2) {
                                return {
                                        tokens: parsed2.tokens,
                                        begin: parsed1.begin,
                                        end: parsed2.end,
                                        data: [
                                          parsed1.data,
                                          parsed2.data
                                        ]
                                      };
                              }));
                }));
  };
}

function seq2(parser1, parser2) {
  return seq2L((function () {
                return parser1;
              }), (function () {
                return parser2;
              }));
}

function seq3L(parser1, parser2, parser3) {
  return map(seq2L((function () {
                    return seq2L(parser1, parser2);
                  }), parser3), (function (param) {
                var match = param[0];
                return [
                        match[0],
                        match[1],
                        param[1]
                      ];
              }));
}

function seq3(parser1, parser2, parser3) {
  return seq3L((function () {
                return parser1;
              }), (function () {
                return parser2;
              }), (function () {
                return parser3;
              }));
}

function anyL(parsers) {
  return function (inp) {
    return Core__Array.reduce(parsers, undefined, (function (res, parser) {
                  if (res !== undefined) {
                    return res;
                  } else {
                    return parser()(inp);
                  }
                }));
  };
}

function any(parsers) {
  return anyL(parsers.map(function (p) {
                  return function () {
                    return p;
                  };
                }));
}

function oneOf(values) {
  return any(values.map(function (val) {
                  return match(function (t) {
                              if (Caml_obj.equal(t, val)) {
                                return Caml_option.some(t);
                              }
                              
                            });
                }));
}

function val(value) {
  return oneOf([value]);
}

function nonEmpty(parser) {
  return mapOpt(parser, (function (ds) {
                if (ds.length === 0) {
                  return ;
                } else {
                  return ds;
                }
              }));
}

function end(parser) {
  return function (inp) {
    var parsed = parser(inp);
    if (parsed !== undefined && isEmpty(toInput(parsed))) {
      return parsed;
    }
    
  };
}

function withCallbacks(parser, before, onSuccess, onFail) {
  return function (inp) {
    Core__Option.forEach(before, (function (before) {
            before(inp);
          }));
    var parsed = parser(inp);
    if (parsed !== undefined) {
      Core__Option.forEach(onSuccess, (function (onSuccess) {
              onSuccess(parsed);
            }));
      return parsed;
    } else {
      Core__Option.forEach(onFail, (function (onFail) {
              onFail(inp);
            }));
      return ;
    }
  };
}

exports.parseL = parseL;
exports.parse = parse;
exports.makeParserInput = makeParserInput;
exports.toInput = toInput;
exports.isEmpty = isEmpty;
exports.mapParsed = mapParsed;
exports.map = map;
exports.mapOpt = mapOpt;
exports.flatMap = flatMap;
exports.match = match;
exports.oneOf = oneOf;
exports.val = val;
exports.rep = rep;
exports.repL = repL;
exports.opt = opt;
exports.optL = optL;
exports.seq = seq;
exports.seq2 = seq2;
exports.seq3 = seq3;
exports.seqL = seqL;
exports.seq2L = seq2L;
exports.seq3L = seq3L;
exports.any = any;
exports.anyL = anyL;
exports.nonEmpty = nonEmpty;
exports.end = end;
exports.withCallbacks = withCallbacks;
/* No side effect */
